import { deTrailingSlash } from './url';
export const getCurrentHref = (noTrailingSlash = true, location = window.location) => (noTrailingSlash ? deTrailingSlash(location.href) : location.href);
export const getCurrentOrigin = (location = window.location) => location.origin;
//# sourceMappingURL=location.js.map